module.exports = __webpack_public_path__ + "img/manda_008.e6eed6ee.png";